"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PinpointDialogSk", {
    enumerable: true,
    get: function() {
        return PinpointDialogSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _task = require("@lit/task");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
const _aloginsk = require("../../../infra-sk/modules/alogin-sk/alogin-sk");
require("../window/window");
require("@material/web/dialog/dialog.js");
require("@material/web/tabs/tabs.js");
require("@material/web/tabs/primary-tab.js");
require("@material/web/textfield/outlined-text-field.js");
require("@material/web/button/filled-button.js");
require("@material/web/button/text-button.js");
require("@material/web/progress/circular-progress.js");
require("@material/web/icon/icon.js");
require("@material/web/checkbox/checkbox.js");
const _testpath = require("../common/test-path");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _PinpointDialogSk;
let PinpointDialogSk = (_PinpointDialogSk = class PinpointDialogSk extends _lit.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.stopProp);
        this.addEventListener('pointerdown', this.stopProp);
        this.addEventListener('mousedown', this.stopProp);
        void (0, _aloginsk.LoggedIn)().then((status)=>{
            this.user = status.email;
        }).catch(_errorMessage.errorMessage);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.stopProp);
        this.removeEventListener('pointerdown', this.stopProp);
        this.removeEventListener('mousedown', this.stopProp);
    }
    async open(mode, params) {
        var _this__dialog;
        this.mode = mode;
        this.testPath = params.testPath || '';
        this.bugId = params.bugId || '';
        this.startCommit = params.startCommit || params.baseCommit || '';
        this.endCommit = params.endCommit || '';
        this.story = params.story || '';
        this.anomalyId = params.anomalyId || '';
        this.configuration = params.configuration || '';
        this.benchmark = params.benchmark || '';
        this.patch = '';
        this.useNewPinpoint = false;
        this._bisectRequest = null;
        this._tryRequest = null;
        await this.updateComplete;
        await customElements.whenDefined('md-dialog');
        (_this__dialog = this._dialog) === null || _this__dialog === void 0 ? void 0 : _this__dialog.show();
    }
    close() {
        var _this__dialog;
        (_this__dialog = this._dialog) === null || _this__dialog === void 0 ? void 0 : _this__dialog.close();
    }
    _validateBisect(req) {
        const rules = [
            {
                val: req.test_path,
                err: 'Test path is missing in the request.'
            },
            {
                val: req.start_git_hash,
                err: 'Start commit is required.'
            },
            {
                val: req.end_git_hash,
                err: 'End commit is required.'
            },
            {
                val: req.configuration,
                err: 'Configuration is missing in the request.'
            },
            {
                val: req.benchmark,
                err: 'Benchmark is missing in the request.'
            },
            {
                val: req.story,
                err: 'Story is missing in the request.'
            },
            {
                val: req.chart,
                err: 'Chart is missing in the request.'
            },
            {
                val: req.user,
                err: 'User is not logged in.'
            }
        ];
        for (const r of rules){
            if (!r.val) {
                void (0, _errorMessage.errorMessage)(r.err);
                return false;
            }
        }
        return true;
    }
    _getProjectAndRepo() {
        var _window_perf_git_repo_url, _window_perf;
        let project = 'chromium';
        let repo = 'chromium';
        if ((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : (_window_perf_git_repo_url = _window_perf.git_repo_url) === null || _window_perf_git_repo_url === void 0 ? void 0 : _window_perf_git_repo_url.includes('skia')) {
            project = 'skia';
            repo = 'skia';
        }
        return {
            project,
            repo
        };
    }
    submitBisect() {
        const parsedPath = (0, _testpath.parseTestPath)(this.testPath);
        const { project } = this._getProjectAndRepo();
        const req = {
            comparison_mode: 'performance',
            start_git_hash: this.startCommit,
            end_git_hash: this.endCommit,
            configuration: parsedPath.configuration,
            benchmark: parsedPath.benchmark,
            story: this.story || parsedPath.story,
            chart: parsedPath.chart,
            statistic: parsedPath.statistic,
            comparison_magnitude: '',
            pin: this.patch,
            project: project,
            bug_id: this.bugId,
            user: this.user,
            alert_ids: '[' + this.anomalyId + ']',
            test_path: this.testPath,
            extra_test_args: this.traceArgs ? JSON.stringify([
                '--extra-chrome-categories',
                this.traceArgs
            ]) : '',
            use_new_pinpoint: this.useNewPinpoint
        };
        if (this._validateBisect(req)) {
            this._bisectRequest = req;
        }
    }
    submitTry() {
        const parsedPath = (0, _testpath.parseTestPath)(this.testPath);
        const config = this.configuration || parsedPath.configuration || this.testPath.split('/')[1] || '';
        const bench = this.benchmark || parsedPath.benchmark || this.testPath.split('/')[2] || '';
        const story = this.story || parsedPath.story || '';
        const { project, repo } = this._getProjectAndRepo();
        const req = {
            name: `Tracing Debug on ${config}/${bench}/${story}`,
            base_git_hash: this.startCommit,
            end_git_hash: this.endCommit,
            base_patch: '',
            experiment_patch: '',
            configuration: config,
            benchmark: bench,
            story: story,
            repository: repo,
            bug_id: '',
            user: this.user,
            project: project,
            extra_test_args: JSON.stringify([
                '--extra-chrome-categories',
                this.traceArgs
            ]),
            use_new_pinpoint: this.useNewPinpoint
        };
        if (!req.base_git_hash || !req.end_git_hash) {
            void (0, _errorMessage.errorMessage)('Base and Experiment commits are required.');
            return;
        }
        if (!req.story) {
            void (0, _errorMessage.errorMessage)('Story is required for try jobs.');
            return;
        }
        this._tryRequest = req;
    }
    _showNewPinpointBackendCheckbox() {
        var _window_perf;
        return !!((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.show_new_pinpoint_backend_checkbox);
    }
    render() {
        const isPending = this._postBisectTask.status === _task.TaskStatus.PENDING || this._postTryTask.status === _task.TaskStatus.PENDING;
        return (0, _lit.html)`
      <md-dialog id="dialog" @close=${this.close}>
        <span slot="headline">
          ${this.mode === 'bisect' ? 'Performance Bisection' : 'Debug Traces'}
        </span>

        <div slot="content">
          <md-tabs>
            <md-primary-tab
              ?active=${this.mode === 'bisect'}
              @click=${()=>{
            this.mode = 'bisect';
        }}>
              <md-icon slot="icon">insights</md-icon>
              Bisect
            </md-primary-tab>
            <md-primary-tab
              ?active=${this.mode === 'try'}
              @click=${()=>{
            this.mode = 'try';
        }}>
              <md-icon slot="icon">history_toggle_off</md-icon>
              Debug
            </md-primary-tab>
          </md-tabs>

          ${this.mode === 'bisect' ? this._renderBisectForm() : this._renderTryForm()}
          ${this._showNewPinpointBackendCheckbox() ? (0, _lit.html)`
                <label class="checkbox-container">
                  <md-checkbox
                    id="use-new-pinpoint"
                    ?checked=${this.useNewPinpoint}
                    @change=${(e)=>{
            this.useNewPinpoint = e.target.checked;
        }}>
                  </md-checkbox>
                  Use new Pinpoint Service (Temporal workflows)
                </label>
              ` : ''}
          ${this._renderStatus()}
        </div>

        <div slot="actions">
          ${isPending ? (0, _lit.html)`
                <div class="loading-indicator">
                  <md-circular-progress indeterminate></md-circular-progress>
                  Submitting to Pinpoint...
                </div>
              ` : ''}
          <md-text-button @click=${this.close}>Cancel</md-text-button>
          <md-filled-button
            ?disabled=${isPending || !this.user}
            @click=${this.mode === 'bisect' ? this.submitBisect : this.submitTry}>
            ${this.mode === 'bisect' ? 'Start Bisect' : 'Generate'}
          </md-filled-button>
        </div>
      </md-dialog>
    `;
    }
    _renderBisectForm() {
        return (0, _lit.html)`
      <div class="form-container">
        <md-outlined-text-field
          label="Test Path *"
          .value=${this.testPath}
          @input=${(e)=>{
            this.testPath = e.target.value;
        }}>
        </md-outlined-text-field>

        <div class="form-row">
          <md-outlined-text-field
            label="Bug ID"
            .value=${this.bugId}
            @input=${(e)=>{
            this.bugId = e.target.value;
        }}>
          </md-outlined-text-field>
          <md-outlined-text-field
            label="Story *"
            .value=${this.story}
            @input=${(e)=>{
            this.story = e.target.value;
        }}>
          </md-outlined-text-field>
        </div>

        <div class="form-row">
          <md-outlined-text-field
            label="Start Commit *"
            .value=${this.startCommit}
            @input=${(e)=>{
            this.startCommit = e.target.value;
        }}>
          </md-outlined-text-field>
          <md-outlined-text-field
            label="End Commit *"
            .value=${this.endCommit}
            @input=${(e)=>{
            this.endCommit = e.target.value;
        }}>
          </md-outlined-text-field>
        </div>

        <md-outlined-text-field
          label="Patch (Optional)"
          placeholder="cl/12345 or git hash"
          .value=${this.patch}
          @input=${(e)=>{
            this.patch = e.target.value;
        }}>
        </md-outlined-text-field>
      </div>
    `;
    }
    _renderTryForm() {
        return (0, _lit.html)`
      <div class="form-container">
        <div class="form-row">
          <md-outlined-text-field
            label="Base Commit *"
            .value=${this.startCommit}
            @input=${(e)=>{
            this.startCommit = e.target.value;
        }}>
          </md-outlined-text-field>
          <md-outlined-text-field
            label="Experiment Commit *"
            .value=${this.endCommit}
            @input=${(e)=>{
            this.endCommit = e.target.value;
        }}>
          </md-outlined-text-field>
        </div>

        <md-outlined-text-field
          label="Tracing Arguments *"
          .value=${this.traceArgs}
          @input=${(e)=>{
            this.traceArgs = e.target.value;
        }}>
        </md-outlined-text-field>
        <div class="help-text">
          Learn more about
          <a
            href="https://source.chromium.org/chromium/chromium/src/+/main:base/trace_event/trace_config.h;l=167"
            target="_blank">
            filter strings
          </a>
        </div>
      </div>
    `;
    }
    _renderStatus() {
        const activeTask = this.mode === 'bisect' ? this._postBisectTask : this._postTryTask;
        return activeTask.render({
            complete: (json)=>{
                if (!json) return (0, _lit.html)``;
                const url = json.jobUrl || json.job_url;
                if (!url) return (0, _lit.html)``;
                return (0, _lit.html)`
          <div class="success-banner">
            <span class="success-title">Pinpoint Job Successfully Created</span>
            <a class="success-link" href="${url}" target="_blank">
              View Pinpoint Job
              <md-icon class="open-in-new-icon">open_in_new</md-icon>
            </a>
          </div>
        `;
            },
            error: (e)=>{
                return (0, _lit.html)`
          <div class="error-banner"><strong>Pinpoint API Error:</strong> ${e.message || e}</div>
        `;
            }
        });
    }
    constructor(...args){
        super(...args);
        this.mode = 'bisect';
        this.useNewPinpoint = false;
        this.testPath = '';
        this.bugId = '';
        this.startCommit = '';
        this.endCommit = '';
        this.story = '';
        this.patch = '';
        this.configuration = '';
        this.benchmark = '';
        // Default TraceEvent categories used by Chromium performance profiling to record top-level task execution and task flow events.
        this.traceArgs = 'toplevel,toplevel.flow,disabled-by-default-toplevel.flow';
        this.anomalyId = '';
        this.user = '';
        this._bisectRequest = null;
        this._tryRequest = null;
        this._postBisectTask = new _task.Task(this, {
            task: async ([req], { signal })=>{
                if (!req) return null;
                const resp = await fetch('/_/bisect/create', {
                    method: 'POST',
                    signal,
                    body: JSON.stringify(req),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                return await (0, _jsonOrThrow.jsonOrThrow)(resp);
            },
            args: ()=>[
                    this._bisectRequest
                ]
        });
        this._postTryTask = new _task.Task(this, {
            task: async ([req], { signal })=>{
                if (!req) return null;
                const resp = await fetch('/_/try/', {
                    method: 'POST',
                    signal,
                    body: JSON.stringify(req),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                return await (0, _jsonOrThrow.jsonOrThrow)(resp);
            },
            args: ()=>[
                    this._tryRequest
                ]
        });
        this.stopProp = (e)=>e.stopPropagation();
    }
}, (()=>{
    _PinpointDialogSk.styles = (0, _lit.css)`
    :host {
      display: block;
    }

    md-dialog {
      --md-dialog-container-color: var(--surface);
      --md-dialog-headline-color: var(--on-surface);
      --md-dialog-supporting-text-color: var(--secondary);

      min-width: 480px;
      max-width: 560px;
    }

    md-tabs {
      margin-bottom: 16px;

      --md-tabs-primary-tab-label-text-color: var(--secondary);
      --md-tabs-primary-tab-active-label-text-color: var(--primary);
      --md-tabs-primary-tab-active-indicator-color: var(--primary);
    }

    .form-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 4px 0;
    }

    .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }

    md-outlined-text-field {
      width: 100%;

      --md-outlined-text-field-container-shape: 4px;
      --md-outlined-text-field-outline-color: var(--outline);
      --md-outlined-text-field-focus-outline-color: var(--primary);
      --md-outlined-text-field-input-text-color: var(--on-surface);
      --md-outlined-text-field-label-text-color: var(--secondary);
      --md-outlined-text-field-focus-label-text-color: var(--primary);
    }

    .help-text {
      font-size: 12px;
      color: var(--secondary);
      margin-top: -10px;
      padding-left: 4px;
    }

    .help-text a {
      color: var(--primary);
      text-decoration: none;
    }

    .help-text a:hover {
      text-decoration: underline;
    }

    .success-banner {
      background-color: color-mix(in srgb, var(--primary) 10%, transparent);
      border: 1px solid color-mix(in srgb, var(--primary) 20%, transparent);
      border-radius: 8px;
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-top: 16px;
    }

    .success-title {
      font-size: 13px;
      font-weight: 600;
      color: var(--on-surface);
    }

    .success-link {
      font-size: 13px;
      color: var(--primary);
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-family: monospace;
    }

    .success-link:hover {
      text-decoration: underline;
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 16px;
    }

    md-filled-button {
      --md-filled-button-container-color: var(--primary);
      --md-filled-button-label-text-color: var(--on-primary);
      --md-filled-button-container-shape: 20px;
    }

    md-text-button {
      --md-text-button-label-text-color: var(--primary);
      --md-text-button-container-shape: 20px;
    }

    .loading-indicator {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 13px;
      color: var(--secondary);
      margin-right: auto;
    }

    md-circular-progress {
      --md-circular-progress-active-indicator-color: var(--primary);
    }

    .error-banner {
      color: var(--error);
      background-color: color-mix(in srgb, var(--error) 10%, transparent);
      border: 1px solid color-mix(in srgb, var(--error) 20%, transparent);
      border-radius: 8px;
      padding: 12px;
      margin-top: 16px;
      font-size: 13px;
    }

    .checkbox-container {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: var(--secondary);
      cursor: pointer;
      margin-top: 16px;
      margin-bottom: 8px;
      user-select: none;
    }

    .open-in-new-icon {
      font-size: 14px;
      margin-left: 2px;
    }
  `;
})(), _PinpointDialogSk);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof PinpointMode === "undefined" ? Object : PinpointMode)
], PinpointDialogSk.prototype, "mode", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "useNewPinpoint", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "testPath", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "bugId", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "startCommit", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "endCommit", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "story", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "patch", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "configuration", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "benchmark", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "traceArgs", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "anomalyId", void 0);
_ts_decorate([
    (0, _decorators.state)()
], PinpointDialogSk.prototype, "user", void 0);
_ts_decorate([
    (0, _decorators.query)('#dialog'),
    _ts_metadata("design:type", Object)
], PinpointDialogSk.prototype, "_dialog", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], PinpointDialogSk.prototype, "_bisectRequest", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], PinpointDialogSk.prototype, "_tryRequest", void 0);
PinpointDialogSk = _ts_decorate([
    (0, _decorators.customElement)('pinpoint-dialog-sk')
], PinpointDialogSk);
